module.exports = __webpack_public_path__ + "img/newsExperience3.54bea0e5.png";